import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';
import { useFormikContext } from 'formik';

const PermitId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  const { values } = useFormikContext();

  return (
    <FormikInput
      value={values.permitId}
      placeholder="Enter permit ID"
      id="permitId"
      name="permitId"
      label="Permit ID"
      data-testid="ui-field-permit-id"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default PermitId;
